module.exports = __webpack_public_path__ + "static/media/RP-74.8ba8c9f3.pdf";